import { checkForRemovedLinks } from './checkForRemovedLinks';
import { X_OWA_AUTO_LINKS_CLASSNAME } from './constants';
import { LinkIdContainer } from 'owa-attachment-link-common';
import { OWA_AUTO_LINKS_CLASSNAME } from 'owa-compose-link';
import { IEditor } from 'roosterjs-editor-types';

export default async function getAllSharingLinks(
    editor: IEditor,
    linkIdContainer: LinkIdContainer
): Promise<void> {
    if (!editor) {
        return;
    }

    const existingLinkIdMap: { [key: string]: boolean } = {};
    getLinksBasedOnClassName(OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
    getLinksBasedOnClassName(X_OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
    checkForRemovedLinks(linkIdContainer, existingLinkIdMap);
}

function getLinksBasedOnClassName(
    className: string,
    editor: IEditor,
    existingLinkIdMap: { [key: string]: boolean }
) {
    editor.queryElements('.' + className, link => {
        existingLinkIdMap[link.id] = true;
    });
}
